import {
  Companion_getInstance1tv6bohtg8v20 as Companion_getInstance,
  AccessAndFeedback14j91frzc8fa0 as AccessAndFeedback,
  AccessInfoj60d6hx1qs8r as AccessInfo,
} from './supportModels.mjs';
import {
  properties1qnxlk10mmfrs as properties,
  get_serializableAnnotations132wwdaanmitj as get_serializableAnnotations,
  SerializableProperty3ugfzrmvjw266 as SerializableProperty,
} from '../../../lightning-server-shared/com/lightningkite/serialization/SerializableProperty.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer } from '../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { lazy2hsh8ze7j6ikd as lazy } from '../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import { KProperty1ca4yb4wlo496 as KProperty1 } from '../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { emptySetcxexqki71qfa as emptySet } from '../../../kotlin-kotlin-stdlib/kotlin/collections/Sets.mjs';
import { KtSetjrjc7fhfd6b9 as KtSet } from '../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function prepareAccessAndFeedbackFields() {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var props = [AccessAndFeedback_access_getInstance(), AccessAndFeedback_feedback_getInstance(), AccessAndFeedback_readBy_getInstance()];
  var tmp = Companion_getInstance().m2a();
  properties(tmp, (it) => props);
}
function AccessAndFeedback_access$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(0);
}
function AccessAndFeedback_access$_get_name_$ref_gx20k8() {
  return (p0) => p0.k20();
}
function AccessAndFeedback_access$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[0];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function AccessAndFeedback_access$_get_serializer_$ref_fsdzep() {
  return (p0) => p0.j2j();
}
function AccessAndFeedback_access$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(0);
}
function AccessAndFeedback_access$_get_annotations_$ref_nvfyot() {
  return (p0) => p0.bz();
}
var AccessAndFeedback_accessClass;
function AccessAndFeedback_access() {
  if (AccessAndFeedback_accessClass === VOID) {
    class $ {
      constructor() {
        AccessAndFeedback_access_instance = this;
        var tmp = this;
        tmp.n53_1 = lazy(AccessAndFeedback_access$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.o53_1 = lazy(AccessAndFeedback_access$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.p53_1 = lazy(AccessAndFeedback_access$annotations$delegate$lambda);
      }
      k20() {
        var tmp0 = this.n53_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, AccessAndFeedback_access$_get_name_$ref_gx20k8(), null);
        return tmp0.f2();
      }
      q53(receiver) {
        return receiver.r53_1;
      }
      m2j(receiver) {
        return this.q53(receiver instanceof AccessAndFeedback() ? receiver : THROW_CCE());
      }
      u53(receiver, value) {
        return receiver.v53(value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof AccessAndFeedback() ? receiver : THROW_CCE();
        return this.u53(tmp, value instanceof AccessInfo() ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.o53_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, AccessAndFeedback_access$_get_serializer_$ref_fsdzep(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.p53_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, AccessAndFeedback_access$_get_annotations_$ref_nvfyot(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'AccessAndFeedback_access', VOID, VOID, [SerializableProperty()]);
    AccessAndFeedback_accessClass = $;
  }
  return AccessAndFeedback_accessClass;
}
var AccessAndFeedback_access_instance;
function AccessAndFeedback_access_getInstance() {
  if (AccessAndFeedback_access_instance === VOID)
    new (AccessAndFeedback_access())();
  return AccessAndFeedback_access_instance;
}
function AccessAndFeedback_feedback$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(1);
}
function AccessAndFeedback_feedback$_get_name_$ref_u7kjzb() {
  return (p0) => p0.k20();
}
function AccessAndFeedback_feedback$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[1];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function AccessAndFeedback_feedback$_get_serializer_$ref_18ceyo() {
  return (p0) => p0.j2j();
}
function AccessAndFeedback_feedback$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(1);
}
function AccessAndFeedback_feedback$_get_annotations_$ref_m2ztc4() {
  return (p0) => p0.bz();
}
var AccessAndFeedback_feedbackClass;
function AccessAndFeedback_feedback() {
  if (AccessAndFeedback_feedbackClass === VOID) {
    class $ {
      constructor() {
        AccessAndFeedback_feedback_instance = this;
        var tmp = this;
        tmp.w53_1 = lazy(AccessAndFeedback_feedback$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.x53_1 = lazy(AccessAndFeedback_feedback$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.y53_1 = lazy(AccessAndFeedback_feedback$annotations$delegate$lambda);
      }
      k20() {
        var tmp0 = this.w53_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, AccessAndFeedback_feedback$_get_name_$ref_u7kjzb(), null);
        return tmp0.f2();
      }
      q53(receiver) {
        return receiver.s53_1;
      }
      m2j(receiver) {
        return this.q53(receiver instanceof AccessAndFeedback() ? receiver : THROW_CCE());
      }
      z53(receiver, value) {
        return receiver.v53(VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof AccessAndFeedback() ? receiver : THROW_CCE();
        return this.z53(tmp, (!(value == null) ? typeof value === 'string' : false) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.x53_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, AccessAndFeedback_feedback$_get_serializer_$ref_18ceyo(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.y53_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, AccessAndFeedback_feedback$_get_annotations_$ref_m2ztc4(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'AccessAndFeedback_feedback', VOID, VOID, [SerializableProperty()]);
    AccessAndFeedback_feedbackClass = $;
  }
  return AccessAndFeedback_feedbackClass;
}
var AccessAndFeedback_feedback_instance;
function AccessAndFeedback_feedback_getInstance() {
  if (AccessAndFeedback_feedback_instance === VOID)
    new (AccessAndFeedback_feedback())();
  return AccessAndFeedback_feedback_instance;
}
function AccessAndFeedback_readBy$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(2);
}
function AccessAndFeedback_readBy$_get_name_$ref_8h519d() {
  return (p0) => p0.k20();
}
function AccessAndFeedback_readBy$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[2];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function AccessAndFeedback_readBy$_get_serializer_$ref_1liqdk() {
  return (p0) => p0.j2j();
}
function AccessAndFeedback_readBy$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(2);
}
function AccessAndFeedback_readBy$_get_annotations_$ref_5ea9sc() {
  return (p0) => p0.bz();
}
var AccessAndFeedback_readByClass;
function AccessAndFeedback_readBy() {
  if (AccessAndFeedback_readByClass === VOID) {
    class $ {
      constructor() {
        AccessAndFeedback_readBy_instance = this;
        var tmp = this;
        tmp.a54_1 = lazy(AccessAndFeedback_readBy$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.b54_1 = lazy(AccessAndFeedback_readBy$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.c54_1 = lazy(AccessAndFeedback_readBy$annotations$delegate$lambda);
        this.d54_1 = emptySet();
        this.e54_1 = 'emptySet()';
      }
      k20() {
        var tmp0 = this.a54_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, AccessAndFeedback_readBy$_get_name_$ref_8h519d(), null);
        return tmp0.f2();
      }
      q53(receiver) {
        return receiver.t53_1;
      }
      m2j(receiver) {
        return this.q53(receiver instanceof AccessAndFeedback() ? receiver : THROW_CCE());
      }
      f54(receiver, value) {
        return receiver.v53(VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof AccessAndFeedback() ? receiver : THROW_CCE();
        return this.f54(tmp, (!(value == null) ? isInterface(value, KtSet()) : false) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.b54_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, AccessAndFeedback_readBy$_get_serializer_$ref_1liqdk(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.c54_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, AccessAndFeedback_readBy$_get_annotations_$ref_5ea9sc(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'AccessAndFeedback_readBy', VOID, VOID, [SerializableProperty()]);
    AccessAndFeedback_readByClass = $;
  }
  return AccessAndFeedback_readByClass;
}
var AccessAndFeedback_readBy_instance;
function AccessAndFeedback_readBy_getInstance() {
  if (AccessAndFeedback_readBy_instance === VOID)
    new (AccessAndFeedback_readBy())();
  return AccessAndFeedback_readBy_instance;
}
//region block: exports
export {
  prepareAccessAndFeedbackFields as prepareAccessAndFeedbackFields1d9qkivapa7xk,
};
//endregion

//# sourceMappingURL=AccessAndFeedbackFields.mjs.map
